﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconCash } from "@tabler/icons-react";
import { CondicionesPagoDef } from "./CondicionesPagoDef";

export const CondicionesPagoHelpText = '* Aquí puede ver las condiciones de pago.';
export const CondicionesPagoIcon = IconCash;
export class CondicionesPago extends Entity<CondicionesPagoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CondicionesPagoDef(), parentKeys);
        super.Form = import('./CondicionesPagoForm').then((module) => module.CondicionesPagoForm);
        this.Title = 'Condiciones de pago'
        this.Icon = CondicionesPagoIcon;
        this.HelpText = CondicionesPagoHelpText;
    }
}